import styled from 'styled-components'

export const Label = styled.label`
  display: block;
  font-size: ${props => props.theme.typography.fontSize.label};
  font-weight: 400;
  color: ${props => props.theme.colors.text.tertiary};
  margin-bottom: 0.375rem;
  letter-spacing: -0.01em;
  font-family: ${props => props.theme.typography.fontFamily};
`
